import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import i18n from '../utils/locale';

export function notifyError(exception, message = undefined) {
    console.error(exception);
    Sentry.captureException(exception);

    Vue.notify({
        group: 'default',
        title: message || i18n.t('general.something_went_wrong'),
        type: 'error',
        duration: 2500,
        position: 'top right',
    });
}

export function notifySuccess(message) {
    Vue.notify({
        group: 'default',
        title: message,
        type: 'success',
        duration: 2500,
        position: 'top right',
    });
}
